import { render, staticRenderFns } from "./Listprovinsippk.vue?vue&type=template&id=2d572576"
import script from "./Listprovinsippk.vue?vue&type=script&lang=js"
export * from "./Listprovinsippk.vue?vue&type=script&lang=js"
import style0 from "./Listprovinsippk.vue?vue&type=style&index=0&id=2d572576&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports